//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { MEDAL_TYPE } from '@/constant'
const MEDAL_TYPES = Object.keys(MEDAL_TYPE).map(key => MEDAL_TYPE[key])
export default {
    props: {
        item: Object,
        enable_link: Boolean
    },
    methods: {
        openList () {
            const { name } = this.item
            if (this.enable_link && MEDAL_TYPES.indexOf(name) > -1) {
                wx.navigateTo({
                    url: `/pages/consultants/main?medal=${name}`
                })
            }
        }
    }
}
